import RosterContext from "context/roster.context";
import useRosterStorage from "storage/roster";
import ITrainer from "types/Trainer";
import { FunctionComponent, PropsWithChildren, useEffect, useState } from "react";
import { useUser } from "reactfire";

type Props = PropsWithChildren<{}>;

const Container: FunctionComponent<Props> = ({ children }) => {
  const [roster, _setRoster] = useState<ITrainer[]>([]);
  const user = useUser();
  const [published, setPublished] = useState(false);
  const { getRoster, setRoster } = useRosterStorage();
  const [lastUpdate, setLastRosterUpdate] = useState<number>(0);

  useEffect(() => {
    if (user.data?.uid) {
      getRoster(user.data.uid)
        .then(({ trainers, published }) => {
          _setRoster(trainers);
          setPublished(published);
          setLastRosterUpdate(Date.now());
        })
        .catch(console.log);
    } else {
      getRoster()
        .then(({ trainers, published }) => {
          _setRoster(trainers);
          setPublished(published);
          setLastRosterUpdate(Date.now());
        })
        .catch(console.log);
    }
  }, [user.data?.uid]);

  const updateRoster = async (trainers: ITrainer[]) => {
    await setRoster(trainers);

    _setRoster(trainers);
    setLastRosterUpdate(Date.now());
  };

  return (
    <RosterContext.Provider
      value={{
        roster,
        published,
        setRoster: updateRoster,
        updateDate: lastUpdate,
      }}
    >
      {children}
    </RosterContext.Provider>
  );
};

export default Container;
